<template>
  <el-dialog :title="title" :visible.sync="dialogState">
    <slot name="body"></slot>
    <div slot="footer" class="dialog-footer">
      <el-button @click.stop="dialogState = false" type="danger">Cancel</el-button>
      <el-button v-if="confirmBtnText" @click.stop="dialogState = true"  type="primary">{{ confirmBtnText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      title: String,
      visible: {
        type: Boolean,
        default: false,
      },
      confirmBtnText: {
        type: String,
        default: 'Confirm'
      },
    },

    computed: {
      dialogState: {
        get: function() {
          return this.visible
        },
        set: function(value) {
          this.$emit(value ? 'confirm' : 'close', value)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-button--primary {
    background: #26a69a;
  }
  .el-button--danger {
    background: #cc3f55;
  }
</style>
